(() => {
  const wishlistKey = 'eryneWishlist';
  const gridKey = 'eryneCollectionComfortableGrid';

  const readWishlist = () => {
    try {
      const saved = JSON.parse(window.localStorage.getItem(wishlistKey) || '[]');
      return Array.isArray(saved) ? saved : [];
    } catch (error) {
      return [];
    }
  };

  const writeWishlist = (items) => {
    try {
      window.localStorage.setItem(wishlistKey, JSON.stringify(items));
    } catch (error) {
      // Wishlist still works for this page view if storage is unavailable.
    }
  };

  const initCollection = (root) => {
    if (!root || root.dataset.eryneCollectionReady === 'true') return;
    root.dataset.eryneCollectionReady = 'true';

    const filterToggle = root.querySelector('[data-collection-filter-toggle]');
    const filterPanel = root.querySelector('[data-collection-filter-panel]');
    const filterBackdrop = root.querySelector('[data-collection-filter-backdrop]');
    const filterClose = root.querySelector('[data-collection-filter-close]');

    const openFilters = () => {
      if (!filterPanel || !filterBackdrop) return;
      filterPanel.hidden = false;
      filterBackdrop.hidden = false;
      window.requestAnimationFrame(() => {
        filterPanel.classList.add('is-open');
        filterBackdrop.classList.add('is-open');
      });
      document.body.classList.add('eryne-filter-open');
      filterToggle?.setAttribute('aria-expanded', 'true');
      filterClose?.focus();
    };

    const closeFilters = () => {
      if (!filterPanel || !filterBackdrop) return;
      filterPanel.classList.remove('is-open');
      filterBackdrop.classList.remove('is-open');
      document.body.classList.remove('eryne-filter-open');
      filterToggle?.setAttribute('aria-expanded', 'false');
      window.setTimeout(() => {
        if (!filterPanel.classList.contains('is-open')) {
          filterPanel.hidden = true;
          filterBackdrop.hidden = true;
        }
      }, 360);
      filterToggle?.focus();
    };

    filterToggle?.addEventListener('click', openFilters);
    filterClose?.addEventListener('click', closeFilters);
    filterBackdrop?.addEventListener('click', closeFilters);
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && filterPanel?.classList.contains('is-open')) closeFilters();
    });

    const grid = root.querySelector('[data-product-grid]');
    const gridToggle = root.querySelector('[data-grid-toggle]');
    let comfortableGrid = false;
    try {
      comfortableGrid = window.localStorage.getItem(gridKey) === 'true';
    } catch (error) {
      comfortableGrid = false;
    }

    const updateGrid = () => {
      grid?.classList.toggle('is-comfortable', comfortableGrid);
      gridToggle?.setAttribute('aria-pressed', comfortableGrid ? 'true' : 'false');
      gridToggle?.setAttribute('aria-label', comfortableGrid ? 'Show more products per row' : 'Show larger product images');
    };
    updateGrid();

    gridToggle?.addEventListener('click', () => {
      comfortableGrid = !comfortableGrid;
      updateGrid();
      try {
        window.localStorage.setItem(gridKey, comfortableGrid ? 'true' : 'false');
      } catch (error) {
        // Grid toggle remains available for the current page view.
      }
    });

    root.querySelectorAll('[data-product-image-toggle]').forEach((button) => {
      button.addEventListener('click', () => {
        const card = button.closest('[data-product-card]');
        if (!card) return;
        const showingAlternate = card.classList.toggle('is-alt');
        button.setAttribute('aria-label', showingAlternate ? 'Show primary product image' : 'Show alternate product image');
      });
    });

    let wishlist = readWishlist();
    root.querySelectorAll('[data-wishlist-toggle]').forEach((button) => {
      const card = button.closest('[data-product-card]');
      const handle = card?.dataset.productHandle;
      if (!handle) return;

      const updateButton = () => {
        const saved = wishlist.includes(handle);
        button.classList.toggle('is-saved', saved);
        button.setAttribute('aria-pressed', saved ? 'true' : 'false');
        button.setAttribute('aria-label', saved ? 'Remove product from saved pieces' : 'Save product');
      };
      updateButton();

      button.addEventListener('click', () => {
        if (wishlist.includes(handle)) {
          wishlist = wishlist.filter((item) => item !== handle);
        } else {
          wishlist.push(handle);
        }
        writeWishlist(wishlist);
        updateButton();
      });
    });
  };

  const initAll = (scope = document) => {
    scope.querySelectorAll('[data-eryne-collection]').forEach(initCollection);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
